
import * as d from './components';

export const DIRECTIVES = [
  d.CustomerOverviewComponent,
  d.DragAndDropComponent,
  d.DynamicOrderProgressionStepper,
  d.DynamicStepperComponent,
  d.FooterComponent,
  d.HeaderComponent,
  d.InfoComponent,
  d.InputFieldComponent,
  d.LoadingSpinner,
  d.OrderOverviewComponent,
  d.OrderProgressionStep,
  d.OverviewComponent,
  d.RadioButtonComponent,
  d.ShoppingCartView,
  d.SimpleAccordion,
  d.StepComponent,
  d.ThemeButton
];
